import { render, staticRenderFns } from "./Firmware.vue?vue&type=template&id=5b4515c1&scoped=true&"
import script from "./Firmware.vue?vue&type=script&lang=js&"
export * from "./Firmware.vue?vue&type=script&lang=js&"
import style0 from "./Firmware.vue?vue&type=style&index=0&id=5b4515c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4515c1",
  null
  
)

export default component.exports